import { useTranslation } from 'react-i18next'

import { Button, PaddingInset, spacing, Stack, Text } from '@cash-design-system/react'

export const OnboardingValidationCloseContent = ({
  onClickGoBack,
  onClickLogOut,
}: {
  onClickGoBack: () => void
  onClickLogOut: () => void
}) => {
  const { t } = useTranslation()
  return (
    <Stack space={spacing.xxl}>
      <PaddingInset>
        <Stack space={spacing.m}>
          <Text typography="numeralS" as="h2" color="textStandard">
            {t('This information is required to use Cash App.', {
              context: 'header in onboarding validation',
            })}
          </Text>
        </Stack>
      </PaddingInset>
      <Stack space={spacing.l}>
        <Button size="large" onClick={onClickGoBack}>
          {t('Go back', { context: 'button CTA to back to form' })}
        </Button>
        <Button size="large" variant="secondary" onClick={onClickLogOut}>
          {t('Log out', { context: 'button CTA to log out' })}
        </Button>
      </Stack>
    </Stack>
  )
}
